module.exports = __webpack_public_path__ + "static/media/PlusGreen.e21c9283.svg";